import React, { Suspense } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { cn } from 'src/lib/utils'
import { ReactComponent as WalmeLogoFull } from './WalmeLogoFull.svg'
import TokenSaleBanner from '../TokenSaleBanner/TokenSaleBanner'

const HeaderSearch = React.lazy(() => import('./HeaderSearch'))

function Header({ activeTab }) {
  const location = useLocation()

  const isActive = (path) => {
    return location.pathname === path || activeTab === path
  }

  return (
    <>
      <TokenSaleBanner />
      <header className="sticky top-0 z-50 w-full border-b border-walme-border bg-walme-bg/95 backdrop-blur supports-[backdrop-filter]:bg-walme-bg/80">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center">
              <WalmeLogoFull style={{ height: '32px', width: 'auto' }} />
            </Link>

            <nav className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={cn(
                  "px-4 py-2 rounded-lg text-sm font-semibold transition-all",
                  isActive('/')
                    ? "bg-walme-bg-elevated text-walme-text"
                    : "text-walme-text-dim hover:text-walme-text hover:bg-walme-bg-elevated/50"
                )}
              >
                Markets
              </Link>
              <Link
                to="/portfolio"
                className={cn(
                  "px-4 py-2 rounded-lg text-sm font-semibold transition-all",
                  isActive('/portfolio')
                    ? "bg-walme-bg-elevated text-walme-text"
                    : "text-walme-text-dim hover:text-walme-text hover:bg-walme-bg-elevated/50"
                )}
              >
                Portfolio
              </Link>
              <a
                href="https://waitlist.walme.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 rounded-lg text-sm font-semibold text-walme-text-dim hover:text-walme-text hover:bg-walme-bg-elevated/50 transition-all"
              >
                Waitlist
              </a>
            </nav>
          </div>

          <div className="flex items-center">
            <Suspense fallback={null}>
              <HeaderSearch />
            </Suspense>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
